<template>
  <defs>
    <clipPath id="clippath">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-1">
      <rect x="24.55" y="8.89" width="270.9" height="311.14" fill="none" />
    </clipPath>
    <clipPath id="clippath-2">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-3">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-4">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-5">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-6">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-7">
      <rect x="24.55" y="8.89" width="270.9" height="311.18" fill="none" />
    </clipPath>
    <clipPath id="clippath-8">
      <rect x="24.55" y="8.89" width="270.9" height="311.18" fill="none" />
    </clipPath>
    <clipPath id="clippath-9">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-10">
      <rect x="24.55" y="8.89" width="270.9" height="311.11" fill="none" />
    </clipPath>
    <clipPath id="clippath-11">
      <rect width="320" height="320" fill="none" />
    </clipPath>
    <clipPath id="clippath-12">
      <rect width="320" height="320" fill="none" />
    </clipPath>
    <clipPath id="clippath-13">
      <rect x="24.68" y="9.03" width="270.9" height="310.97" fill="none" />
    </clipPath>
    <clipPath id="clippath-14">
      <rect x="44.01" width="237.1" height="320" fill="none" />
    </clipPath>
    <radialGradient
      id="_nihongo_80"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#743c2f" />
      <stop offset=".16" stop-color="#743c2f" stop-opacity=".9" />
      <stop offset=".45" stop-color="#743c2f" stop-opacity=".63" />
      <stop offset=".83" stop-color="#743c2f" stop-opacity=".2" />
      <stop offset="1" stop-color="#743c2f" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_80-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_80"
    />
    <radialGradient
      id="_nihongo_73"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#6f3e33" />
      <stop offset=".17" stop-color="#6f3e33" stop-opacity=".9" />
      <stop offset=".47" stop-color="#6f3e33" stop-opacity=".62" />
      <stop offset=".86" stop-color="#6f3e33" stop-opacity=".17" />
      <stop offset="1" stop-color="#6f3e33" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_73-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_73"
    />
    <radialGradient
      id="_nihongo_68"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#774e49" />
      <stop offset=".16" stop-color="#774e49" stop-opacity=".9" />
      <stop offset=".45" stop-color="#774e49" stop-opacity=".64" />
      <stop offset=".82" stop-color="#774e49" stop-opacity=".22" />
      <stop offset="1" stop-color="#774e49" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_68-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_68"
    />
    <radialGradient
      id="_nihongo_64"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#a05a44" />
      <stop offset=".13" stop-color="#a05a44" stop-opacity=".93" />
      <stop offset=".35" stop-color="#a05a44" stop-opacity=".73" />
      <stop offset=".65" stop-color="#a05a44" stop-opacity=".42" />
      <stop offset="1" stop-color="#a05a44" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_64-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_64"
    />
    <radialGradient
      id="_nihongo_59"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ad6c5c" />
      <stop offset=".12" stop-color="#ad6c5c" stop-opacity=".93" />
      <stop offset=".33" stop-color="#ad6c5c" stop-opacity=".75" />
      <stop offset=".61" stop-color="#ad6c5c" stop-opacity=".46" />
      <stop offset=".95" stop-color="#ad6c5c" stop-opacity=".07" />
      <stop offset="1" stop-color="#ad6c5c" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_59-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_59"
    />
    <radialGradient
      id="_nihongo_53"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ab7864" />
      <stop offset=".12" stop-color="#ab7864" stop-opacity=".93" />
      <stop offset=".34" stop-color="#ab7864" stop-opacity=".75" />
      <stop offset=".62" stop-color="#ab7864" stop-opacity=".46" />
      <stop offset=".96" stop-color="#ab7864" stop-opacity=".06" />
      <stop offset="1" stop-color="#ab7864" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_53-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_53"
    />
    <radialGradient
      id="_nihongo_37"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#f99784" />
      <stop offset=".09" stop-color="#f99784" stop-opacity=".95" />
      <stop offset=".25" stop-color="#fa9a87" stop-opacity=".83" />
      <stop offset=".46" stop-color="#fb9e8b" stop-opacity=".63" />
      <stop offset=".71" stop-color="#fca391" stop-opacity=".35" />
      <stop offset="1" stop-color="#fa9" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_37-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_37"
    />
    <radialGradient
      id="_nihongo_35"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#f6a496" />
      <stop offset=".09" stop-color="#f6a496" stop-opacity=".95" />
      <stop offset=".25" stop-color="#f7a596" stop-opacity=".83" />
      <stop offset=".47" stop-color="#f9a697" stop-opacity=".62" />
      <stop offset=".72" stop-color="#fba797" stop-opacity=".34" />
      <stop offset="1" stop-color="#fa9" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_35-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_35"
    />
    <radialGradient
      id="_nihongo_34"
      cx="156.69"
      cy="185.13"
      fx="156.69"
      fy="185.13"
      r="19.44"
      gradientTransform="translate(51.58 41.79) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#f5b9ad" />
      <stop offset=".1" stop-color="#f5b8ac" stop-opacity=".95" />
      <stop offset=".26" stop-color="#f6b6a9" stop-opacity=".83" />
      <stop offset=".47" stop-color="#f8b3a5" stop-opacity=".62" />
      <stop offset=".72" stop-color="#fbaf9f" stop-opacity=".34" />
      <stop offset="1" stop-color="#fa9" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_34-2"
      cx="862.75"
      cy="394.31"
      fx="862.75"
      fy="394.31"
      r="19.44"
      gradientTransform="translate(430.97 1034.38) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_34"
    />
    <radialGradient
      id="_nihongo_95"
      cx="156.68"
      cy="185.16"
      fx="156.68"
      fy="185.16"
      r="19.44"
      gradientTransform="translate(51.59 41.8) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#fa9" />
      <stop offset=".09" stop-color="#fa9" stop-opacity=".95" />
      <stop offset=".25" stop-color="#fa9" stop-opacity=".83" />
      <stop offset=".45" stop-color="#fa9" stop-opacity=".64" />
      <stop offset=".7" stop-color="#fa9" stop-opacity=".36" />
      <stop offset=".99" stop-color="#fa9" stop-opacity=".02" />
      <stop offset="1" stop-color="#fa9" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_95-2"
      cx="862.74"
      cy="394.34"
      fx="862.74"
      fy="394.34"
      r="19.44"
      gradientTransform="translate(430.99 1034.4) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_95"
    />
    <radialGradient
      id="_nihongo_214"
      cx="156.94"
      cy="184"
      fx="156.94"
      fy="184"
      r="19.44"
      gradientTransform="translate(51.34 41.73) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ffc7b5" />
      <stop offset=".09" stop-color="#ffc7b5" stop-opacity=".95" />
      <stop offset=".25" stop-color="#ffc7b5" stop-opacity=".83" />
      <stop offset=".45" stop-color="#ffc7b5" stop-opacity=".64" />
      <stop offset=".7" stop-color="#ffc7b5" stop-opacity=".36" />
      <stop offset=".99" stop-color="#ffc7b5" stop-opacity=".02" />
      <stop offset="1" stop-color="#ffc7b5" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_214-2"
      cx="863"
      cy="393.17"
      fx="863"
      fy="393.17"
      r="19.44"
      gradientTransform="translate(430.06 1033.63) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_214"
    />
    <radialGradient
      id="_nihongo_20"
      cx="156.68"
      cy="185.16"
      fx="156.68"
      fy="185.16"
      r="19.44"
      gradientTransform="translate(51.59 36.85) scale(.97 .85)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ffd7d2" />
      <stop offset=".09" stop-color="#ffd7d2" stop-opacity=".95" />
      <stop offset=".24" stop-color="#ffd7d2" stop-opacity=".83" />
      <stop offset=".45" stop-color="#ffd7d2" stop-opacity=".64" />
      <stop offset=".7" stop-color="#ffd7d2" stop-opacity=".36" />
      <stop offset=".99" stop-color="#ffd7d2" stop-opacity=".02" />
      <stop offset="1" stop-color="#ffd7d2" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_nihongo_20-2"
      cx="862.74"
      cy="394.34"
      fx="862.74"
      fy="394.34"
      r="19.44"
      gradientTransform="translate(452.25 1034.4) rotate(-90) scale(.97 -.85)"
      xlink:href="#_nihongo_20"
    />
    <radialGradient
      id="_nihongo_80-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_80"
    />
    <radialGradient
      id="_nihongo_80-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_80"
    />
    <radialGradient
      id="_nihongo_73-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_73"
    />
    <radialGradient
      id="_nihongo_73-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_73"
    />
    <radialGradient
      id="_nihongo_68-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_68"
    />
    <radialGradient
      id="_nihongo_68-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_68"
    />
    <radialGradient
      id="_nihongo_64-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_64"
    />
    <radialGradient
      id="_nihongo_64-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_64"
    />
    <radialGradient
      id="_nihongo_59-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_59"
    />
    <radialGradient
      id="_nihongo_59-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_59"
    />
    <radialGradient
      id="_nihongo_53-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_53"
    />
    <radialGradient
      id="_nihongo_53-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_53"
    />
    <radialGradient
      id="_nihongo_37-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_37"
    />
    <radialGradient
      id="_nihongo_37-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_37"
    />
    <radialGradient
      id="_nihongo_35-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_35"
    />
    <radialGradient
      id="_nihongo_35-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_35"
    />
    <radialGradient
      id="_nihongo_34-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      r="19.44"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_34"
    />
    <radialGradient
      id="_nihongo_34-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_34"
    />
    <radialGradient
      id="_nihongo_95-3"
      cx="157.95"
      cy="179.48"
      fx="157.95"
      fy="179.48"
      gradientTransform="translate(50.36 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_95"
    />
    <radialGradient
      id="_nihongo_95-4"
      cx="864.01"
      cy="388.65"
      fx="864.01"
      fy="388.65"
      r="19.44"
      gradientTransform="translate(426.45 1030.64) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_95"
    />
    <radialGradient
      id="_nihongo_214-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_nihongo_214"
    />
    <radialGradient
      id="_nihongo_214-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_214"
    />
    <radialGradient
      id="_nihongo_20-3"
      cx="157.95"
      cy="179.48"
      fx="157.95"
      fy="179.48"
      gradientTransform="translate(50.36 36.69) scale(.97 .85)"
      xlink:href="#_nihongo_20"
    />
    <radialGradient
      id="_nihongo_20-4"
      cx="864.01"
      cy="388.65"
      fx="864.01"
      fy="388.65"
      r="19.44"
      gradientTransform="translate(447.41 1030.64) rotate(-90) scale(.97 -.85)"
      xlink:href="#_nihongo_20"
    />
    <radialGradient
      id="_nihongo_80-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_80"
    />
    <radialGradient
      id="_nihongo_80-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_80"
    />
    <radialGradient
      id="_nihongo_73-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_73"
    />
    <radialGradient
      id="_nihongo_73-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_73"
    />
    <radialGradient
      id="_nihongo_68-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_68"
    />
    <radialGradient
      id="_nihongo_68-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_68"
    />
    <radialGradient
      id="_nihongo_64-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_64"
    />
    <radialGradient
      id="_nihongo_64-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_64"
    />
    <radialGradient
      id="_nihongo_59-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_59"
    />
    <radialGradient
      id="_nihongo_59-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_59"
    />
    <radialGradient
      id="_nihongo_53-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_53"
    />
    <radialGradient
      id="_nihongo_53-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_53"
    />
    <radialGradient
      id="_nihongo_37-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_37"
    />
    <radialGradient
      id="_nihongo_37-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_37"
    />
    <radialGradient
      id="_nihongo_35-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_35"
    />
    <radialGradient
      id="_nihongo_35-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_35"
    />
    <radialGradient
      id="_nihongo_34-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      r="19.44"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_34"
    />
    <radialGradient
      id="_nihongo_34-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_34"
    />
    <radialGradient
      id="_nihongo_95-5"
      cx="159.22"
      cy="173.79"
      fx="159.22"
      fy="173.79"
      r="19.44"
      gradientTransform="translate(49.13 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_95"
    />
    <radialGradient
      id="_nihongo_95-6"
      cx="865.27"
      cy="382.96"
      fx="865.27"
      fy="382.96"
      r="19.44"
      gradientTransform="translate(421.91 1026.87) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_95"
    />
    <radialGradient
      id="_nihongo_214-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_nihongo_214"
    />
    <radialGradient
      id="_nihongo_214-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_nihongo_214"
    />
    <radialGradient
      id="_nihongo_20-5"
      cx="159.22"
      cy="173.79"
      fx="159.22"
      fy="173.79"
      r="19.44"
      gradientTransform="translate(49.13 36.54) scale(.97 .85)"
      xlink:href="#_nihongo_20"
    />
    <radialGradient
      id="_nihongo_20-6"
      cx="865.27"
      cy="382.96"
      fx="865.27"
      fy="382.96"
      r="19.44"
      gradientTransform="translate(442.56 1026.87) rotate(-90) scale(.97 -.85)"
      xlink:href="#_nihongo_20"
    />
    <linearGradient
      id="_nihongo_15"
      x1="-874.51"
      y1="189.07"
      x2="-874.51"
      y2="166.64"
      gradientTransform="translate(-747.87) rotate(-180) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#3f3d3e" />
      <stop offset=".11" stop-color="#373536" />
      <stop offset="1" stop-color="#000" />
    </linearGradient>
    <linearGradient
      id="_nihongo_15-2"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-3"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-4"
      x1="-2858.44"
      y1="189.07"
      x2="-2858.44"
      y2="166.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-5"
      x1="-2858.44"
      y1="189.07"
      x2="-2858.44"
      y2="166.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-6"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-7"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-8"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-9"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-10"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-11"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-12"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-13"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-14"
      x1="-2858.44"
      y1="184.07"
      x2="-2858.44"
      y2="161.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-15"
      x1="-2858.44"
      y1="184.07"
      x2="-2858.44"
      y2="161.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-16"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-17"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-18"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-19"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-20"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-21"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-22"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-23"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-24"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-25"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-26"
      x1="-2858.44"
      y1="179.07"
      x2="-2858.44"
      y2="156.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-27"
      x1="-2858.44"
      y1="179.07"
      x2="-2858.44"
      y2="156.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-28"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-29"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-30"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-31"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-32"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_nihongo_15"
    />
    <linearGradient
      id="_nihongo_15-33"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_nihongo_15"
    />
    <radialGradient
      id="_gradient_95"
      cx="156.68"
      cy="185.16"
      fx="156.68"
      fy="185.16"
      r="19.44"
      gradientTransform="translate(51.59 41.8) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#fa9" />
      <stop offset=".09" stop-color="#fa9" stop-opacity=".95" />
      <stop offset=".25" stop-color="#fa9" stop-opacity=".83" />
      <stop offset=".45" stop-color="#fa9" stop-opacity=".64" />
      <stop offset=".7" stop-color="#fa9" stop-opacity=".36" />
      <stop offset=".99" stop-color="#fa9" stop-opacity=".02" />
      <stop offset="1" stop-color="#fa9" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_gradient_95-2"
      cx="862.74"
      cy="394.34"
      fx="862.74"
      fy="394.34"
      r="19.44"
      gradientTransform="translate(430.99 1034.4) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_95"
    />
    <radialGradient
      id="_gradient_214"
      cx="156.94"
      cy="184"
      fx="156.94"
      fy="184"
      r="19.44"
      gradientTransform="translate(51.34 41.73) scale(.97 .83)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ffc7b5" />
      <stop offset=".09" stop-color="#ffc7b5" stop-opacity=".95" />
      <stop offset=".25" stop-color="#ffc7b5" stop-opacity=".83" />
      <stop offset=".45" stop-color="#ffc7b5" stop-opacity=".64" />
      <stop offset=".7" stop-color="#ffc7b5" stop-opacity=".36" />
      <stop offset=".99" stop-color="#ffc7b5" stop-opacity=".02" />
      <stop offset="1" stop-color="#ffc7b5" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_gradient_214-2"
      cx="863"
      cy="393.17"
      fx="863"
      fy="393.17"
      r="19.44"
      gradientTransform="translate(430.06 1033.63) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_214"
    />
    <radialGradient
      id="_gradient_20"
      cx="156.68"
      cy="185.16"
      fx="156.68"
      fy="185.16"
      r="19.44"
      gradientTransform="translate(51.59 36.85) scale(.97 .85)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#ffd7d2" />
      <stop offset=".09" stop-color="#ffd7d2" stop-opacity=".95" />
      <stop offset=".24" stop-color="#ffd7d2" stop-opacity=".83" />
      <stop offset=".45" stop-color="#ffd7d2" stop-opacity=".64" />
      <stop offset=".7" stop-color="#ffd7d2" stop-opacity=".36" />
      <stop offset=".99" stop-color="#ffd7d2" stop-opacity=".02" />
      <stop offset="1" stop-color="#ffd7d2" stop-opacity="0" />
    </radialGradient>
    <radialGradient
      id="_gradient_20-2"
      cx="862.74"
      cy="394.34"
      fx="862.74"
      fy="394.34"
      r="19.44"
      gradientTransform="translate(452.25 1034.4) rotate(-90) scale(.97 -.85)"
      xlink:href="#_gradient_20"
    />
    <radialGradient
      id="_gradient_95-3"
      cx="157.95"
      cy="179.48"
      fx="157.95"
      fy="179.48"
      gradientTransform="translate(50.36 41.49) scale(.97 .83)"
      xlink:href="#_gradient_95"
    />
    <radialGradient
      id="_gradient_95-4"
      cx="864.01"
      cy="388.65"
      fx="864.01"
      fy="388.65"
      r="19.44"
      gradientTransform="translate(426.45 1030.64) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_95"
    />
    <radialGradient
      id="_gradient_214-3"
      cx="157.96"
      cy="179.45"
      fx="157.96"
      fy="179.45"
      gradientTransform="translate(50.35 41.49) scale(.97 .83)"
      xlink:href="#_gradient_214"
    />
    <radialGradient
      id="_gradient_214-4"
      cx="864.01"
      cy="388.62"
      fx="864.01"
      fy="388.62"
      r="19.44"
      gradientTransform="translate(426.43 1030.62) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_214"
    />
    <radialGradient
      id="_gradient_20-3"
      cx="157.95"
      cy="179.48"
      fx="157.95"
      fy="179.48"
      gradientTransform="translate(50.36 36.69) scale(.97 .85)"
      xlink:href="#_gradient_20"
    />
    <radialGradient
      id="_gradient_20-4"
      cx="864.01"
      cy="388.65"
      fx="864.01"
      fy="388.65"
      r="19.44"
      gradientTransform="translate(447.41 1030.64) rotate(-90) scale(.97 -.85)"
      xlink:href="#_gradient_20"
    />
    <radialGradient
      id="_gradient_95-5"
      cx="159.22"
      cy="173.79"
      fx="159.22"
      fy="173.79"
      r="19.44"
      gradientTransform="translate(49.13 41.18) scale(.97 .83)"
      xlink:href="#_gradient_95"
    />
    <radialGradient
      id="_gradient_95-6"
      cx="865.27"
      cy="382.96"
      fx="865.27"
      fy="382.96"
      r="19.44"
      gradientTransform="translate(421.91 1026.87) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_95"
    />
    <radialGradient
      id="_gradient_214-5"
      cx="159.23"
      cy="173.76"
      fx="159.23"
      fy="173.76"
      gradientTransform="translate(49.12 41.18) scale(.97 .83)"
      xlink:href="#_gradient_214"
    />
    <radialGradient
      id="_gradient_214-6"
      cx="865.28"
      cy="382.93"
      fx="865.28"
      fy="382.93"
      r="19.44"
      gradientTransform="translate(421.89 1026.85) rotate(-90) scale(.97 -.8)"
      xlink:href="#_gradient_214"
    />
    <radialGradient
      id="_gradient_20-5"
      cx="159.22"
      cy="173.79"
      fx="159.22"
      fy="173.79"
      r="19.44"
      gradientTransform="translate(49.13 36.54) scale(.97 .85)"
      xlink:href="#_gradient_20"
    />
    <radialGradient
      id="_gradient_20-6"
      cx="865.27"
      cy="382.96"
      fx="865.27"
      fy="382.96"
      r="19.44"
      gradientTransform="translate(442.56 1026.87) rotate(-90) scale(.97 -.85)"
      xlink:href="#_gradient_20"
    />
    <linearGradient
      id="_gradient_15"
      x1="-874.51"
      y1="189.07"
      x2="-874.51"
      y2="166.64"
      gradientTransform="translate(-747.87) rotate(-180) scale(1 -1)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#3f3d3e" />
      <stop offset=".11" stop-color="#373536" />
      <stop offset="1" stop-color="#000" />
    </linearGradient>
    <linearGradient
      id="_gradient_15-2"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-3"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-4"
      x1="-2858.44"
      y1="189.07"
      x2="-2858.44"
      y2="166.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-5"
      x1="-2858.44"
      y1="189.07"
      x2="-2858.44"
      y2="166.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-6"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-7"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-8"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-9"
      x1="193.59"
      y1="189.07"
      x2="193.59"
      y2="166.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-10"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-11"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-12"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-13"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-14"
      x1="-2858.44"
      y1="184.07"
      x2="-2858.44"
      y2="161.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-15"
      x1="-2858.44"
      y1="184.07"
      x2="-2858.44"
      y2="161.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-16"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-17"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-18"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-19"
      x1="193.59"
      y1="184.07"
      x2="193.59"
      y2="161.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-20"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-21"
      x1="-874.51"
      y1="184.07"
      x2="-874.51"
      y2="161.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-22"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-23"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-24"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-25"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-26"
      x1="-2858.44"
      y1="179.07"
      x2="-2858.44"
      y2="156.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-27"
      x1="-2858.44"
      y1="179.07"
      x2="-2858.44"
      y2="156.64"
      gradientTransform="translate(-2731.79) rotate(-180) scale(1 -1)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-28"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-29"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-30"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-31"
      x1="193.59"
      y1="179.07"
      x2="193.59"
      y2="156.64"
      gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-32"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_gradient_15"
    />
    <linearGradient
      id="_gradient_15-33"
      x1="-874.51"
      y1="179.07"
      x2="-874.51"
      y2="156.64"
      xlink:href="#_gradient_15"
    />
  </defs>
</template>

<script>
export default {
  name: 'defAvatar',
}
</script>
